import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
const _excluded = ["static"],
  _excluded2 = ["unmount"],
  _excluded3 = ["as", "children", "refName"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import E, { Fragment as j, cloneElement as v, createElement as S, forwardRef as w, isValidElement as k, useCallback as x, useRef as M } from "react";
import { classNames as N } from './class-names.js';
import { match as O } from './match.js';
var A = (a => (a[a.None = 0] = "None", a[a.RenderStrategy = 1] = "RenderStrategy", a[a.Static = 2] = "Static", a))(A || {}),
  C = (e => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(C || {});
function K() {
  let n = $();
  return x(r => U(_objectSpread({
    mergeRefs: n
  }, r)), [n]);
}
function U(_ref) {
  let {
    ourProps: n,
    theirProps: r,
    slot: e,
    defaultTag: a,
    features: s,
    visible: t = !0,
    name: l,
    mergeRefs: i
  } = _ref;
  i = i != null ? i : I;
  let o = P(r, n);
  if (t) return F(o, e, a, l, i);
  let y = s != null ? s : 0;
  if (y & 2) {
    let {
        static: f = !1
      } = o,
      u = _objectWithoutProperties(o, _excluded);
    if (f) return F(u, e, a, l, i);
  }
  if (y & 1) {
    let {
        unmount: f = !0
      } = o,
      u = _objectWithoutProperties(o, _excluded2);
    return O(f ? 0 : 1, {
      [0]() {
        return null;
      },
      [1]() {
        return F(_objectSpread(_objectSpread({}, u), {}, {
          hidden: !0,
          style: {
            display: "none"
          }
        }), e, a, l, i);
      }
    });
  }
  return F(o, e, a, l, i);
}
function F(n) {
  let r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let e = arguments.length > 2 ? arguments[2] : undefined;
  let a = arguments.length > 3 ? arguments[3] : undefined;
  let s = arguments.length > 4 ? arguments[4] : undefined;
  let _h = h(n, ["unmount", "static"]),
    {
      as: t = e,
      children: l,
      refName: i = "ref"
    } = _h,
    o = _objectWithoutProperties(_h, _excluded3),
    y = n.ref !== void 0 ? {
      [i]: n.ref
    } : {},
    f = typeof l == "function" ? l(r) : l;
  "className" in o && o.className && typeof o.className == "function" && (o.className = o.className(r)), o["aria-labelledby"] && o["aria-labelledby"] === o.id && (o["aria-labelledby"] = void 0);
  let u = {};
  if (r) {
    let d = !1,
      p = [];
    for (let [c, T] of Object.entries(r)) typeof T == "boolean" && (d = !0), T === !0 && p.push(c.replace(/([A-Z])/g, g => "-".concat(g.toLowerCase())));
    if (d) {
      u["data-headlessui-state"] = p.join(" ");
      for (let c of p) u["data-".concat(c)] = "";
    }
  }
  if (b(t) && (Object.keys(m(o)).length > 0 || Object.keys(m(u)).length > 0)) if (!k(f) || Array.isArray(f) && f.length > 1 || D(f)) {
    if (Object.keys(m(o)).length > 0) throw new Error(['Passing props on "Fragment"!', "", "The current component <".concat(a, " /> is rendering a \"Fragment\"."), "However we need to passthrough the following props:", Object.keys(m(o)).concat(Object.keys(m(u))).map(d => "  - ".concat(d)).join("\n"), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map(d => "  - ".concat(d)).join("\n")].join("\n"));
  } else {
    let d = f.props,
      p = d == null ? void 0 : d.className,
      c = typeof p == "function" ? function () {
        return N(p(...arguments), o.className);
      } : N(p, o.className),
      T = c ? {
        className: c
      } : {},
      g = P(f.props, m(h(o, ["ref"])));
    for (let R in u) R in g && delete u[R];
    return v(f, Object.assign({}, g, u, y, {
      ref: s(H(f), y.ref)
    }, T));
  }
  return S(t, Object.assign({}, h(o, ["ref"]), !b(t) && y, !b(t) && u), f);
}
function $() {
  let n = M([]),
    r = x(e => {
      for (let a of n.current) a != null && (typeof a == "function" ? a(e) : a.current = e);
    }, []);
  return function () {
    for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
      e[_key] = arguments[_key];
    }
    if (!e.every(a => a == null)) return n.current = e, r;
  };
}
function I() {
  for (var _len2 = arguments.length, n = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    n[_key2] = arguments[_key2];
  }
  return n.every(r => r == null) ? void 0 : r => {
    for (let e of n) e != null && (typeof e == "function" ? e(r) : e.current = r);
  };
}
function P() {
  var a;
  for (var _len3 = arguments.length, n = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    n[_key3] = arguments[_key3];
  }
  if (n.length === 0) return {};
  if (n.length === 1) return n[0];
  let r = {},
    e = {};
  for (let s of n) for (let t in s) t.startsWith("on") && typeof s[t] == "function" ? ((a = e[t]) != null || (e[t] = []), e[t].push(s[t])) : r[t] = s[t];
  if (r.disabled || r["aria-disabled"]) for (let s in e) /^(on(?:Click|Pointer|Mouse|Key)(?:Down|Up|Press)?)$/.test(s) && (e[s] = [t => {
    var l;
    return (l = t == null ? void 0 : t.preventDefault) == null ? void 0 : l.call(t);
  }]);
  for (let s in e) Object.assign(r, {
    [s](t) {
      let i = e[s];
      for (var _len4 = arguments.length, l = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        l[_key4 - 1] = arguments[_key4];
      }
      for (let o of i) {
        if ((t instanceof Event || (t == null ? void 0 : t.nativeEvent) instanceof Event) && t.defaultPrevented) return;
        o(t, ...l);
      }
    }
  });
  return r;
}
function V() {
  var a;
  for (var _len5 = arguments.length, n = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    n[_key5] = arguments[_key5];
  }
  if (n.length === 0) return {};
  if (n.length === 1) return n[0];
  let r = {},
    e = {};
  for (let s of n) for (let t in s) t.startsWith("on") && typeof s[t] == "function" ? ((a = e[t]) != null || (e[t] = []), e[t].push(s[t])) : r[t] = s[t];
  for (let s in e) Object.assign(r, {
    [s]() {
      let l = e[s];
      for (let i of l) i == null || i(...arguments);
    }
  });
  return r;
}
function Y(n) {
  var r;
  return Object.assign(w(n), {
    displayName: (r = n.displayName) != null ? r : n.name
  });
}
function m(n) {
  let r = Object.assign({}, n);
  for (let e in r) r[e] === void 0 && delete r[e];
  return r;
}
function h(n) {
  let r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let e = Object.assign({}, n);
  for (let a of r) a in e && delete e[a];
  return e;
}
function H(n) {
  return E.version.split(".")[0] >= "19" ? n.props.ref : n.ref;
}
function b(n) {
  return n === j || n === Symbol.for("react.fragment");
}
function D(n) {
  return b(n.type);
}
export { A as RenderFeatures, C as RenderStrategy, m as compact, Y as forwardRefWithAs, b as isFragment, D as isFragmentInstance, V as mergeProps, K as useRender };